// extracted by mini-css-extract-plugin
export default {"a":"LoginForm_a__3SxVp","additionalText":"LoginForm_additionalText__Ei-Oo","changeLanguage":"LoginForm_changeLanguage__fUVxs"};